module.exports = __webpack_public_path__ + "img/couples-070.f453fafc.jpg";